export enum ETimeType {
  OPTIMAL_CONTACT_TIME_MORNING = 'morning',
  OPTIMAL_CONTACT_TIME_MIDDAY = 'midday',
  OPTIMAL_CONTACT_TIME_EVENING = 'evening',
}
